// extracted by mini-css-extract-plugin
export default {"img_container":"styles_img_container__tFvC+"};